import Transaction from "../models/Transaction";

export const TransactionMixin = {
    data() {
        return {}
    },
    methods: {
        initialize(side) {
            return new Transaction({
                side: side,
                tag: undefined,
                currency_acronym: undefined,
                amount: undefined,
                rebit_account_id: undefined,
                payment_details: undefined,
                incoming_payment_method_id: undefined,
                outgoing_payment_method_id: undefined,
                txid: undefined,
                admin_id: undefined,
                status: 'accepted',
                transfer_reference: undefined,
                references: undefined,
                bank_date: undefined,
                transaction_id: undefined,
                description: undefined
            })
        }
    }
}
